import { ROUTE_URL, MAP_STORE_ICON } from 'basic/config';

export * from 'basic/config';


ROUTE_URL.USEFUL = '/useful';
ROUTE_URL.HOUSING = '/housing';
ROUTE_URL.PROMO = '/promo';
ROUTE_URL.MATERIALS = '/materials';
ROUTE_URL.SUBSCRIBE = '/subscribe';
ROUTE_URL.COMPANYEVENTS = '/company-events';

export { ROUTE_URL };

export const HAS_CART = true;
export const HAS_DELIVERY = true;
export const HAS_CONTACTS_BUTTON = true;
export const HAS_CONTACTS_PHONE1 = true;
export const HAS_CONTACTS_PHONE2 = true;
export const HAS_CONTACTS_EMAIL = true;
export const HAS_MESSAGES = true;


MAP_STORE_ICON.url = `${process.env.PUBLIC_URL}/assets/images/delivery.png`;

export const GOODS_CATEGORY_MENU = true;

export const SHOW_GREETINGS_SPLASH = 'splash';
